import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import './missionblocknew.css'
import { renderToastWarn } from 'utils/ToastUtils'
import FilterSVG from 'component/svgComponents/filter'
import Col from 'component/utils/Col'
import ContentHeader from 'component/utils/ContentHeader'
import FilterForm from 'component/stockTransfer/MissionBlockFilterForm'
import MissionBlockModalNew from 'component/stockTransfer/MissionBlockModalNew'
import MissionBlockModalErrorNew from 'component/stockTransfer/MissionBlockErrorModalNew'
import MissionBlockEditModal from 'component/stockTransfer/MissionBlockEditModalNew'
import Title from 'component/stockTransfer/MissionBlockTitleNew'
import SideFilterForm from 'component/stockTransfer/MissionBlockSideFilterFormNew'
import Table from 'component/stockTransfer/MissionBlockTableNew'
import Row from 'component/utils/Row'
import * as stockTransferReportActions from 'action/stockTransferReport'
import * as depositActions from 'action/deposit'
import NewPagination from 'component/pagination/newPagination'
import SizeSelect, {components} from 'react-select'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import { colourStyles } from 'utils/selectStyle'
import MissionBlockAddOrRemoveModal from '../../components/stockTransfer/MissionBlockAddOrRemoveModal'
import {UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS} from 'actionTypes'


const DEFAULT_PAGINATION = {
  hasPagination: true,
  page: 1,
  size: 10,
}

const DEFAULT_INITIAL_VALUES = {
  dsMission: '',
  idSourceDepositList: [],
  idDestinationDepositList: [],
}

const EXTRA_SMALL_SCREEN = 768

const MissionBlockContainer = ({
  auth: {
    user: { dsToken },
  },
  count,
  current,
  depositList,
  fetchDepositList,
  fetchMissionDepositBlock,
  missionBlockError,
  missionBlockList,
  pages,
  saveMissionDepositBlock,
  updateAllMissionDepositBlock,
  translate,
}) => {
  const [openEditModal, setOpenEditModal] = useState(null)
  const [openAddOrRemoveModal, setOpenAddOrRemoveModal] = useState(false)
  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [optionSize, setOptionSize] = useState(10)
  const [cdMissionList, setCdMissionList] = useState([])

  const headerRef = useRef(null)
  const filterRef = useRef(null)
  const tableRef = useRef(null)

  const [filters, setFilters] = useState(DEFAULT_INITIAL_VALUES)
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION)
  const [sideFilterElement, setSideFilterElement] = useState(null)
  const [sideFilterVisible, setSideFilterVisible] = useState(false)
  const [sideFilterWidth, setSideFilterWidth] = useState(0)
  const [depositListWithoutPermission, setDepositListWithoutPermission] = useState([])
  const [topMargin, setTopMargin] = useState(0)
  const [missionListSelected, setMissionListSelected] = useState([])
  const [actionMode, setActionMode] = useState(false)

  // Did mount
  useEffect(() => {
    fetchDepositList(dsToken)


  }, [])

  useEffect(() => {
    if(depositList.length > 0 && depositListWithoutPermission.length === 0) {

      const newDeposit = [...depositList]
      newDeposit.push({idDeposit: "", dsDeposit: "Sem permissões"})
      setDepositListWithoutPermission(newDeposit)
    }
  }, [depositList])

  // When error changes
  useEffect(() => {
    if (missionBlockError) renderToastWarn(missionBlockError)
  }, [missionBlockError])

  // When filters change
  useEffect(() => {

    const param = {
      ...filters,
      ...DEFAULT_PAGINATION,
      page: 1,
      size: optionSize
    }

    fetchMissionDepositBlock(dsToken, param)
  }, [filters])

  // When pagination changes
  useEffect(() => {

    handleFetchMissionDepositBlock()
  }, [pagination])

  // Will unmount
  useEffect(() => () => window.removeEventListener('resize', handleResize))

  const handleResize = () => {
    const header = headerRef.current

    if (header && window.innerWidth > EXTRA_SMALL_SCREEN) {
      const headerClientHeight = header.clientHeight

      const filter = filterRef.current

      const topHeight = headerClientHeight + filter.clientHeight

      let newSideFilterWidth = sideFilterWidth

      filter.style.top = `${headerClientHeight}px`

      if (sideFilterVisible && sideFilterElement)
        newSideFilterWidth = sideFilterElement.clientWidth

      if (topMargin !== topHeight || sideFilterWidth !== newSideFilterWidth) {
        setSideFilterWidth(newSideFilterWidth)

        setTopMargin(topHeight)
      }
    }
  }

  const handleFetchMissionDepositBlock = () => {
    const param = {
      ...filters,
      ...pagination,
    }

    fetchMissionDepositBlock(dsToken, param)
  }

  const closeFilter = () => setSideFilterVisible(false)

  const resetFilters = () => setValues(DEFAULT_INITIAL_VALUES)

  const setValues = (values) => {

    setFilters({ ...filters, ...values, page: 1, o: Math.random })
  }


  const renderNewPagination = () => {
    const PAGINATION_OPTIONS = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '30', value: 30 },
      { label: '40', value: 40 },
    ]

    const countItems = () => {


      if(current === 1) return 1


      return ((current - 1) * optionSize) + 1
    }

    const DropdownIndicator = props => (
      <components.DropdownIndicator {...props}>
        <DropdownArrow />
      </components.DropdownIndicator>
    )

    useEffect(() => {
      setPagination({...pagination, page: 1, size: optionSize})
    }, [optionSize])

    if(!missionBlockList.length) return

    return (
    <Row className="new-relatory-row stock-transfer-pagination" >
                      <Col className="align-center margin-bottom ">


                      <NewPagination
                      navClass='pagination new-relatory'
                      count={count}
                      current={current}
                      getPage={(page) => setPagination({ ...pagination, size: optionSize,  page })}
                      pages={pages}
                    />

                    <div  className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
                            <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}</Col>
                            <Col xs={4}>
                              <SizeSelect
                              components={{DropdownIndicator}}

                                isSearchable={false}
                                styles={colourStyles}
                                classNamePrefix='react-select'
                                onChange={(option) => setOptionSize(option.value)}
                                options={PAGINATION_OPTIONS}
                                value={PAGINATION_OPTIONS.find((i) => i.value === optionSize)}
                                menuPlacement='top'
                              />
                            </Col>
                      </div>


                      <div style={{float: 'left'}} className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
                            <Col >{`
                            ${translate('pagination.size.show')}
                            ${countItems()} - ${current * optionSize > count ? count : current * optionSize }
                            ${translate("pagination.size.of")}
                            ${count}
                            ${translate("pagination.size.items")}`}</Col>

                      </div>

                    </Col>


                  </Row>
    )
  }

  const renderEditModal = () => {
    if (!openEditModal) return

    const getInitialValues = () => {
      const getDepositIds = (depositList) =>
        depositList.map((deposit) => deposit.idDeposit)

      const initialValues = {
        dsMission: openEditModal.dsMission,
        idSourceDepositList: getDepositIds(openEditModal.sourceDepositList),
        idDestinationDepositList: getDepositIds(
          openEditModal.destinationDepositList
        ),
      }

      return initialValues
    }

    return (
      <MissionBlockEditModal
        closeModal={() => setOpenEditModal(null)}
        depositList={depositList}
        initialValues={getInitialValues()}
        submit={beforeSave}
        translate={translate}
      />
    )
  }

  useEffect(() => {
    if(cdMissionList.length === 0) {
      setMissionListSelected([])
      return
    }
    const selecteds = [...missionBlockList].filter(mission => cdMissionList.includes(mission.cdMission))
    const cloneSelecteds = [...missionListSelected]
    selecteds.forEach((element) => {
      const findMission = missionListSelected.filter(mission => element.cdMission === mission.cdMission).length > 0
      if(!findMission) cloneSelecteds.push(element)
    })
    setMissionListSelected(cloneSelecteds)
  },[cdMissionList])

  const removeSelected = (cdMission) => {
    const hasSelected = missionBlockList.filter(mission => mission.cdMission === cdMission).length > 0
    if(hasSelected) {
      const newSelecteds = [...missionListSelected].filter(mission => mission.cdMission !== cdMission)

      setMissionListSelected(newSelecteds)
    }
  }

  const renderAddOrRemoveModal = () => {

    if(!openAddOrRemoveModal) return

    return (
      <MissionBlockAddOrRemoveModal
        closeModal={() => setOpenAddOrRemoveModal(false)}
        depositList={depositList}
        missionList={missionListSelected}
        updateAll={updateAll}
        submit={beforeSave}
        translate={translate}
      />
    )
  }


  const renderErrorModal = () => {
    if(!openErrorModal) return
    return (
      <MissionBlockModalErrorNew
        onConfirm={() => setOpenErrorModal(false)}
        text={translate('lmexpress.parameter.update-fail')}
        title={translate('modal.error.title')}
        okButton={translate('close_button_label')}
      />
    )
  }

  const renderSuccessModal = () => {
    if (!openSuccessModal) return

    return (
      <MissionBlockModalNew
        onConfirm={() => setOpenSuccessModal(false)}
        text={translate('new.home.quickAccess.add.descriptionModal')}
        title={translate('missionMenu.successModal.title.6')}
        okButton={translate('close_button_label')}
      />
    )
  }

  const depositsToIds = (deposits) => deposits.map(dep => dep.idDeposit)

  const updateAll = async (values) => {
    const DTOValues = [...values].map(mission => ({cdMission: mission.cdMission, dsMission: mission.dsMission,idSourceDepositList: depositsToIds(mission.sourceDepositList),  idDestinationDepositList: depositsToIds(mission.destinationDepositList), }))
    const body = DTOValues


    const fetchParam = {
      ...filters,
      ...DEFAULT_PAGINATION,
      page: current,
      size: optionSize
    }

    const response = await updateAllMissionDepositBlock(dsToken, body)
    setOpenAddOrRemoveModal(false)
    setCdMissionList([])
    if(response.type === UPDATE_ALL_STOCK_TRANSFER_MISSION_BLOCK_SUCCESS) setOpenSuccessModal(true)
    else setOpenErrorModal(true)
    fetchMissionDepositBlock(dsToken, fetchParam)


  }
  const beforeSave = async (values) => {
    const param = {
      ...values,
      cdMissionList: openEditModal ? [openEditModal.cdMission] : cdMissionList,
    }
    setOpenEditModal(null)
    setCdMissionList([])

    await saveMissionDepositBlock(dsToken, param)

    setOpenSuccessModal(true)

    const fetchParam = {
      ...filters,
      ...DEFAULT_PAGINATION,
      page: current,
      size: optionSize
    }

    fetchMissionDepositBlock(dsToken, fetchParam)
  }

  useEffect(() => {
    if(cdMissionList.length > 0 && !actionMode) {
      setActionMode(true)
    }

  }, [cdMissionList])

  const inActionMode = cdMissionList.length > 0

  return (
    <div className='stock-adjustment'>
      <div ref={headerRef} className='stock-adjustment-header'>
        <ContentHeader>{translate('stockTransfer.missionBlock.header.new')}</ContentHeader>
      </div>
      <div ref={filterRef} className='padding-bottom header-mission-block'>
          <div style={{display: inActionMode ? 'none' : ''}}>
            <FilterForm  visible={!actionMode} submit={setValues} translate={translate} />
          </div>
          <Title
            cdMissionListLength={cdMissionList.length}
            handleSideFilterMenuCollapseChange={setSideFilterVisible}
            setCdMissionList={setCdMissionList}
            setAddOrRemoveModal={setOpenAddOrRemoveModal}
            sideFilterVisible={sideFilterVisible}
            translate={translate}
          />
          <button style={{display: inActionMode ? 'none' : '', marginRight: '27px'}} className='btn filter-mission-block' onClick={() => setSideFilterVisible(true)}>
                <FilterSVG newDesign={false} className="common-download"/>
                <span>{translate('commonReport.filters')}</span>
              </button>

      </div>
      <div
        style={{ margin: '0 !important' }}
        ref={tableRef}
        className='stock-adjustment-table new'
      >

          <div style={{boxShadow: missionBlockList.length < 1 && 'none'}} className='outer-table stock-transfer-outer-table'>
            <div className='flex'>
              <SideFilterForm
                resetFilters={resetFilters}
                closeFilters={closeFilter}
                depositList={depositListWithoutPermission}
                handleSideFilterElementChange={setSideFilterElement}
                initialValues={DEFAULT_INITIAL_VALUES}
                sideFilterVisible={sideFilterVisible}
                submit={setValues}
                translate={translate}
              />
              {missionBlockList.length ? (
                <Table
                 removeSelected={removeSelected}
                  cdMissionList={cdMissionList}
                  handleResize={handleResize}
                  openModal={setOpenEditModal}
                  records={missionBlockList}
                  setCdMissionList={setCdMissionList}
                  translate={translate}
                />
              ) : (
                <div style={{width: '100%', height: '500px', margin: '0px'}} className='relatory-no-data'> <span>{translate("useraccess.data.isempty")}</span> </div>
              )}
            </div>
           {renderNewPagination()}
          </div>

      </div>
      {renderEditModal()}

      {renderAddOrRemoveModal()}
      {renderErrorModal()}
      {renderSuccessModal()}

    </div>
  )
}

MissionBlockContainer.propTypes = {
  auth: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  depositList: PropTypes.array.isRequired,
  fetchDepositList: PropTypes.func.isRequired,
  fetchMissionDepositBlock: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  menu: PropTypes.object.isRequired,
  missionBlockError: PropTypes.object,
  missionBlockList: PropTypes.array.isRequired,
  pages: PropTypes.number.isRequired,
  saveMissionDepositBlock: PropTypes.func.isRequired,
  updateAllMissionDepositBlock: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

/* istanbul ignore next */
const mapStateToProps = ({
  stockTransferReportReducer,
  depositReducer,
  paginateReducer,
}) => ({
  ...stockTransferReportReducer,
  ...paginateReducer,
  depositList: depositReducer.list,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...stockTransferReportActions,
      fetchDepositList: depositActions.fetch,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    MissionBlockContainer
  )
)

export { MissionBlockContainer }
